import React from "react";
import { Search } from "lucide-react";
import { Input } from "../../../components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

export function TestPlanFilters({ filters, onFilterChange }) {
  return (
    <div
      className="flex flex-wrap items-center gap-3 md:gap-4"
      data-testid="test-plan-filters"
    >
      <div className="flex items-center gap-2">
        <span className="whitespace-nowrap text-sm font-medium text-text-secondary">
          Assign To:
        </span>
        <Select
          value={filters.assignTo}
          onValueChange={(v) => onFilterChange("assignTo", v)}
        >
          <SelectTrigger
            className="w-[150px] rounded-lg border-gray-200"
            aria-label="Assign to"
          >
            <SelectValue placeholder="All" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="me">Me</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <span className="whitespace-nowrap text-sm font-medium text-text-secondary">
          Sort:
        </span>
        <Select
          value={filters.sort}
          onValueChange={(v) => onFilterChange("sort", v)}
        >
          <SelectTrigger
            className="w-[160px] rounded-lg border-gray-200"
            aria-label="Sort"
          >
            <SelectValue placeholder="Most Recent" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="most_recent">Most Recent</SelectItem>
            <SelectItem value="name">Name</SelectItem>
            <SelectItem value="status">Status</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <span className="whitespace-nowrap text-sm font-medium text-text-secondary">
          Status:
        </span>
        <Select
          value={filters.status}
          onValueChange={(v) => onFilterChange("status", v)}
        >
          <SelectTrigger
            className="w-[130px] rounded-lg border-gray-200"
            aria-label="Status filter"
          >
            <SelectValue placeholder="All" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="ACTIVE">Active</SelectItem>
            <SelectItem value="COMPLETED">Completed</SelectItem>
            <SelectItem value="ARCHIVED">Archive</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="relative min-w-[200px] flex-1 md:max-w-md md:flex-initial">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          className="rounded-lg border-gray-200 pl-9"
          placeholder="Search test plan..."
          value={filters.search}
          onChange={(e) => onFilterChange("search", e.target.value)}
          aria-label="Search test plans"
        />
      </div>
    </div>
  );
}
